var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"edit",rawName:"v-edit:block",value:(_vm.contentId),expression:"contentId",arg:"block"}],staticClass:"usp-block"},[_c('ica-large-media-card',_vm._b({on:{"button-click":_vm.trackClick}},'ica-large-media-card',{
      buttonLabel: _vm.buttonLabel,
      'content': _vm.$options.filters.stringify(_vm.content),
      editPrefix: _vm.editPrefix,
      imageDisplayMode: _vm.imageDisplayMode,
      mediaPlacement: _vm.mediaPlacement,
      name: _vm.name,
      prefix: _vm.prefix,
      title: _vm.title,
      url: _vm.url,
      videoUrl: _vm.videoUrl,
      labelText: _vm.labelText,
      isPrimaryButton: _vm.isPrimaryButton
    },false),[(!_vm.videoUrl && _vm.image)?_c('epi-picture',{directives:[{name:"edit",rawName:"v-edit",value:('Image'),expression:"'Image'"}],class:{'object-fill': _vm.imageDisplayMode === 'ImageFill' && !_vm.isIE11},attrs:{"slot":"media","use-picture":true,"auto-aspect-ratio":_vm.aspectRatioMode,"image":_vm.image,"sizes":_vm.dimensions,"sharpen":80,"auto-quality":"best","dynamic-dimensions":_vm.imageDisplayMode === 'ImageFill'},slot:"media"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }